exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".page-max[data-v-99906acc]{max-height:calc(100vh - 100px);overflow:scroll}.tips[data-v-99906acc]{color:#999}.upLoadPicBox .upLoad[data-v-99906acc],.upLoadPicBox .pictrue[data-v-99906acc]{width:80px;height:80px}.sort-img[data-v-99906acc]{display:-webkit-box;display:-ms-flexbox;display:flex}", ""]);

// exports
